import React from 'react';
import GridIcon from 'ui/elements/icons/GridIcon';
import ListIcon from 'ui/elements/icons/ListIcon';
import Tabs from 'ui/modules/tabs/Tabs';
import Tab from 'ui/modules/tabs/Tab';
import { CompanyViewModes } from './useViewMode';
import IconButton from 'ui/elements/icons/IconButton';

const tabStyle = {
  marginRight: '0',
  minWidth: '0',
};

export default function ToggleViewMode({
  size,
  viewMode,
  setViewMode,
}: {
  size?: 'default' | 'compact';
  viewMode: CompanyViewModes;
  setViewMode: (viewMode: CompanyViewModes) => void;
}) {
  if (size === 'compact') {
    return (
      <span className="u-flex-end">
        <IconButton onClick={() => setViewMode('grid')} color={viewMode === 'grid' ? 'blue' : 'dark-grey'}>
          <GridIcon fontSize="small" />
        </IconButton>
        <IconButton onClick={() => setViewMode('list')} color={viewMode === 'list' ? 'blue' : 'dark-grey'}>
          <ListIcon fontSize="small" />
        </IconButton>
      </span>
    );
  }
  return (
    <div className="u-content-spacing-left u-flex-grow">
      <Tabs activeTab={viewMode} onChange={activeTab => setViewMode(activeTab)} hideTabIndicator={true} align="right">
        <Tab value="grid" label="grid" icon={<GridIcon fontSize="small" />} aria-label="Grid view" sx={tabStyle} />
        <Tab value="list" label="list" icon={<ListIcon fontSize="small" />} aria-label="List view" sx={tabStyle} />
      </Tabs>
    </div>
  );
}
